<template>
    <div class="container-main">
<!--        <span class="item">-->
<!--            <router-link to="/ijmt" style="width:100%;height:100%;">-->
<!--                <div class="main_image">-->
<!--                    <img class="main_picture" src="/img/iljinm_main.png" style="width:100%;height:100%;object-fit: cover;">-->
<!--                    <h1 class="main_image_text" style="font-size: 32px">롯데에너지머티리얼즈</h1>-->
<!--                    <p class="main_image_hide">lotte energy materials</p>-->
<!--                    <div class="inside_border"></div>-->
<!--                </div>-->
<!--            </router-link>-->
<!--        </span>-->
        <span class="item">
            <router-link to="/ijst" style="width:100%;height:100%;">
                <div class="main_image">
                    <img class="main_picture" src="/img/iljinst_main.png" style="width:100%;height:100%;object-fit: cover;">
                    <h1 class="main_image_text">일진 제강</h1>
                    <p class="main_image_hide">iljin steel</p>
                    <div class="inside_border"></div>
                </div>
            </router-link>
        </span>
        <span class="item">
            <router-link to="/ijel" style="width:100%;height:100%;">
                <div class="main_image">
                    <img class="main_picture" src="/img/iljinel_main.png" style="width:100%;height:100%;object-fit: cover;">
                    <h1 class="main_image_text">일진 전기</h1>
                    <p class="main_image_hide">iljin electric</p>
                    <div class="inside_border"></div>
                </div>
            </router-link>
        </span>
        <span class="item">
            <router-link to="/ijhd" style="width:100%;height:100%;">
                <div class="main_image">
                    <img class="main_picture" src="/img/iljinhd_main.png" style="width:100%;height:100%;object-fit: cover;">
                    <h1 class="main_image_text">일진 홀딩스</h1>
                    <p class="main_image_hide">iljin holdings</p>
                    <div class="inside_border"></div>
                </div>
            </router-link>
        </span>
        <span class="item">
            <router-link to="/ijdm" style="width:100%;height:100%;">
                <div class="main_image">
                    <img class="main_picture" src="/img/iljindm_main.png" style="width:100%;height:100%;object-fit: cover;">
                    <h1 class="main_image_text">일진 다이아몬드</h1>
                    <p class="main_image_hide">iljin diamond</p>
                    <div class="inside_border"></div>
                </div>
            </router-link>
        </span>
        <span class="item">
            <router-link to="/ijap" style="width:100%;height:100%;">
                <div class="main_image">
                    <img class="main_picture" src="/img/iljinap_main.png" style="width:100%;height:100%;object-fit: cover;">
                    <h1 class="main_image_text" style="font-size: 32px">알피니언 메디칼시스템</h1>
                    <p class="main_image_hide">alpinion medical systems</p>
                    <div class="inside_border"></div>
                </div>
            </router-link>
        </span>
        <span class="item">
          <router-link to="/ijmt" style="width:100%;height:100%;">
          <div class="main_image">
          <img class="main_picture" src="/img/iljinm_main.png" style="width:100%;height:100%;object-fit: cover;">
          <h1 class="main_image_text" style="font-size: 32px">롯데에너지머티리얼즈</h1>
          <p class="main_image_hide">lotte energy materials</p>
          <div class="inside_border"></div>
          </div>
          </router-link>
      </span>

    </div>

</template>

<script>

    export default {
        name: 'GroupMain',
        components: {
        },
        data() {
            return {
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
        },
    };
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.container-main {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
}

.main_image {
    width:100%;
    height:100%;
    position: relative;
}

.main_picture {
    transition-duration: .3s;
    transition-timing-function: ease-out;
}

.main_image_text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate( -50%, -50% );
    color: white;
    font-size: 43px;
    #font-weight: bold;
    font-family: 'Do Hyeon', sans-serif;
}

.main_image_hide {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate( -50%, -50% );
    color: white;
    font-size: 25px;
    font-family: 'Bebas Neue', cursive;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    -o-transition: 0.2s;
    -ms-transition: 0.2s;
    transition: 0.2s;
    opacity: 0;
}

.main_image:hover .main_image_hide{
    -webkit-transform: scale(1.2,1.2);
    -moz-transform: scale(1.2,1.2);
    -o-transform: scale(1.2,1.2);
    -ms-transform: scale(1.2,1.2);
    transform: scale(1.2,1.2) translate( -40%, -40% );
    opacity: 1;
}

.main_image:hover .main_picture{
    color:#FFF;
    opacity: 0.3;
    transition-duration: .3s;
    transition-timing-function: ease-out;
}


.inside_border {
    position: absolute;
    width: 90%;
    height: 90%;
    top: 50%;
    left: 50%;
    transform: translate( -50%, -50% );
    border : solid 3px white;
    transition-duration: .3s;
    opacity: 0;
}

.main_image:hover .inside_border{
    transition-duration: .3s;
    opacity: 1;
}


@media (max-width:1401px) {
    .container-main {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr;
    }

    .main_image_text {font-size:28px;}
}

@media (max-width:938px) {
    .container-main {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
    }

    .main_image_text {font-size:28px;}
}
</style>
